import { Constants as WorkerConstants } from '../../../common/fuse/fuseSearch.constants.js';
/**
 * Constants used in the product center search component.
 */
export const Constants = {
  TAG_NAME: 'pop-pc-search-worker-tester-component',
  MessageTypes: {
    SEARCH_TERM: WorkerConstants.MessageType.SEARCH_TERM,
    FUND_DATA: WorkerConstants.MessageType.FUND_DATA,
  },
  SEARCH_KEYS: WorkerConstants.SEARCH_KEYS,
} as const;
